export default __webpack_public_path__ + "static/media/balma (1).8736bc86.svg";